"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.578 4.862a.7.7 0 0 1 .966-.22l3.67 2.309a1.54 1.54 0 0 1 0 2.607l-3.67 2.309a.7.7 0 1 1-.746-1.185l3.67-2.309a.14.14 0 0 0 0-.237l-3.67-2.308a.7.7 0 0 1-.22-.966m-3.41-.24a.7.7 0 0 1 .361.613v6.04a.7.7 0 0 1-1.072.592L3.786 9.558a1.54 1.54 0 0 1 0-2.607l3.67-2.308a.7.7 0 0 1 .712-.02m-5.055 7.161a.7.7 0 0 1 .969-.205l3.553 2.31q.24.156.496.278a.7.7 0 0 1-.603 1.263 6 6 0 0 1-.656-.368l-3.553-2.31a.7.7 0 0 1-.206-.968m13.774 0a.7.7 0 0 1-.205.969l-3.554 2.31q-.318.206-.655.367a.7.7 0 0 1-.604-1.263q.255-.122.496-.278l3.554-2.31a.7.7 0 0 1 .968.205",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 2.469a.7.7 0 0 1 .7.7V16.83a.7.7 0 1 1-1.4 0V3.17a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=VersionCompareIcon20.js.map